module.exports = __webpack_public_path__ + "static/media/gls_leg_l.4204a121.png";